import { render } from "./app-form-date.vue?vue&type=template&id=de445862"
import script from "./app-form-date.vue?vue&type=script&lang=js"
export * from "./app-form-date.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/app-form-date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de445862"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de445862', __exports__)) {
    console.log('reload')
    api.reload('de445862', __exports__)
  }
  
  module.hot.accept("./app-form-date.vue?vue&type=template&id=de445862", () => {
    console.log('re-render')
    api.rerender('de445862', render)
  })

}


export default __exports__